<template>
  <v-dialog v-model="dialog" width="780px">
    <v-card class="pb-6">
      <v-card-title class="blue darken-4 white--text"
        >SỬA CHUYÊN CẦN
        <v-spacer></v-spacer>
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <div class="d-flex pa-4">
        <v-col cols="4" class="py-0">
          <div class="text-caption my-0">Học sinh</div>
          <CardStudentName :isShowCode="false" :student="student" />
        </v-col>
        <v-col class="d-flex justify-space-between align-center py-0" cols="8">
          <div>
            <div class="text-caption my-0">Ngày sinh</div>
            <span class="black--text">{{ student.dob | ddmmyyyy }}</span>
          </div>
          <v-spacer></v-spacer>
          <div>
            <div class="text-caption my-0">Mã số</div>
            <span class="black--text">{{ student.code }}</span>
          </div>
          <v-spacer></v-spacer>
          <div>
            <div class="text-caption my-0">Lớp</div>
            <span class="black--text">{{ student | getStudentClassName }}</span>
          </div>
        </v-col>
      </div>
      <v-col class="d-flex px-8 pt-0" cols="10">
        <div>
          <div class="text-caption my-0">Số ngày nghỉ</div>
          <span class="black--text">{{ studentDiligences.length }}</span>
        </div>
        <v-spacer></v-spacer>
        <div>
          <div class="text-caption my-0">Nghỉ có phép</div>
          <span class="black--text">{{ studentDiligences.filter(d => d.type === 'valid').length }}</span>
        </div>
        <v-spacer></v-spacer>
        <div>
          <div class="text-caption my-0">Nghỉ không phép</div>
          <span class="black--text">{{ studentDiligences.filter(d => d.type === 'invalid').length }}</span>
        </div>
      </v-col>

      <v-card class="pt-4 mx-6 elevation-1">
        <v-data-table
          mobile-breakpoint="0"
          :items="studentDiligences"
          :headers="headers"
          outlined
          :footer-props="{ 'items-per-page-text': 'Hiển thị mỗi trang', 'items-per-page-all-text': 'Tất cả' }"
        >
          <template #footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} trên
            {{ items.itemsLength }}
          </template>
          <template v-slot:top v-if="$auth.policies['add-new-diligence']">
            <div></div>
            <div class="d-flex justify-end mr-4">
              <v-btn @click="btnclickAddDayOff" color="#0D47A1" outlined class="mb-4">
                <v-icon left>add</v-icon>Thêm ngày nghỉ
              </v-btn>
            </div>
          </template>
          <template v-slot:no-data>
            <div>Học sinh chưa nghỉ</div>
          </template>
          <template #item.dayOff="{ item }">
            {{ item.date | ddmmyyyy }}
          </template>
          <template #item.allowedDayoff="{ item }">
            <v-icon v-if="item.type && item.type === 'valid'">mdi-check</v-icon>
          </template>
          <template #item.unallowedDayoff="{ item }">
            <v-icon v-if="item.type && item.type === 'invalid'">mdi-check</v-icon>
          </template>
          <template #item.action="{ item }">
            <v-icon v-if="$auth.policies['update-diligence']" @click="btnclick(item)">mdi-pencil</v-icon>
            <v-icon v-if="$auth.policies['delete-diligence']" @click="deleteDiligence(item.id)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-card>
      <EditDiligenceDialog :state="editDiligence" :diligence="selectedDiligence" @updateDiligence="updateDiligence" />
      <AddDiligenceDialog :state="newDialog" :student="student" @createdDiligence="createdDiligence" />
    </v-card>
  </v-dialog>
</template>

<script>
import CardStudentName from '@/views/student/components/CardStudentName.vue'
import EditDiligenceDialog from './EditDiligenceDialog'
import AddDiligenceDialog from './AddDiligenceDialog'
import { orderBy } from 'lodash'
import { mapActions } from 'vuex'

const originHeaders = [
  {
    text: 'Ngày nghỉ',
    value: 'dayOff',
    align: 'left',
    sortable: true,
    show: true
  },
  {
    text: 'Nghỉ có phép',
    value: 'allowedDayoff',
    align: 'center',
    sortable: true,
    show: true
  },
  {
    text: 'Nghỉ không phép',
    value: 'unallowedDayoff',
    align: 'center',
    sortable: true,
    show: true
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: true,
    show: true
  }
]
export default {
  components: {
    CardStudentName,
    EditDiligenceDialog,
    AddDiligenceDialog
  },
  props: {
    state: Boolean,
    isShowCode: {
      type: Boolean,
      default: true
    },
    student: Object,
    currentClass: null,
    diligences: {
      type: Array,
      default: () => []
    },
    edit: Boolean
  },
  data() {
    return {
      headers: originHeaders,
      dayOff: [],
      date: null,
      dialog: false,
      grade: '',
      text: 'Ngày nghỉ',
      value: 'time',
      sortable: false,
      editDiligence: false,
      selectedType: '',
      newDialog: false,
      deleteState: false,
      selectedDiligence: {},
      studentDiligences: []
    }
  },
  watch: {
    state() {
      this.dialog = true
    },
    diligences(newValue) {
      if (newValue) {
        const studentDiligences = newValue
        this.studentDiligences = orderBy(studentDiligences, ['date'], ['desc'])
      }
    }
  },
  methods: {
    ...mapActions('Diligence', ['removeDiligence']),
    cancel() {
      this.dialog = false
    },
    getData() {
      if (this.$refs.form.validate()) {
        return {
          student: this.student,
          classData: this.class,
          diligences: this.diligences
        }
      }
    },
    btnclick(item) {
      this.editDiligence = !this.editDiligence
      this.selectedDiligence = item
    },
    btnclickAddDayOff() {
      this.newDialog = !this.newDialog
    },
    createdDiligence(diligence) {
      this.$emit('createdDiligence')
      const studentDiligences = [...this.studentDiligences, diligence]
      this.studentDiligences = orderBy(studentDiligences, ['date'], ['desc'])
    },
    updateDiligence(diligence) {
      this.$emit('updateDiligence')
      this.studentDiligences = this.studentDiligences.map(d => {
        if (diligence.id === d.id) return diligence
        else return d
      })
    },
    deleteDiligence(id) {
      this.$dialog.confirm({
        title: 'Xóa ngày nghỉ này',
        text: `Ngày nghỉ sẽ bị xóa khỏi danh sách chuyên cần và không thể hoàn tác lại được.`,
        okText: 'Xóa',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.removeDiligence(id)
            this.$alert.deleteSuccess()
            this.studentDiligences = this.studentDiligences.filter(d => d.id !== id)
            this.$emit('deletedDiligence')
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  },
  filters: {
    getStudentClassName(student) {
      if (!student || !student.currentClass) return ''
      return student.currentClass.title
    }
  }
}
</script>
